module.exports = __webpack_public_path__ + "static/l-01-0cb0c49be63bb7d1db65018cd210b63b.svg";